const GROUP_URL = process.env.API_URL + '/group/';

const getGroups = (context) => {
  return context.$http.get(GROUP_URL);
};

const createGroup = (context, group) => {
  return context.$http.post(GROUP_URL, group);
};

const updateGroup = (context, group) => {
  return context.$http.put(GROUP_URL, group);
};

const deleteGroup = (context, groupId) => {
  return context.$http.delete(GROUP_URL, {params: {id: groupId}});
};

const addUserIntoGroup = (context, groupId, userId) => {
  return context.$http.post(GROUP_URL + groupId + /user/ + userId);
};

const removeUserFromGroup = (context, groupId, userId) => {
  return context.$http.delete(GROUP_URL + groupId + /user/ + userId);
};

const getUsersOfGroup = (context, groupId) => {
  return context.$http.get(GROUP_URL + groupId + '/user/');
};

const getPermissionsOfGroup = (context, groupId) => {
  return context.$http.get(GROUP_URL + groupId + '/permission/');
};

const setPermissionsOfGroup = (context, groupId, permissions) => {
  return context.$http.put(GROUP_URL + groupId + '/permission/', permissions);
};

export default {
  getGroups,
  createGroup,
  updateGroup,
  deleteGroup,
  addUserIntoGroup,
  removeUserFromGroup,
  getUsersOfGroup,
  getPermissionsOfGroup,
  setPermissionsOfGroup
};



// WEBPACK FOOTER //
// ./src/api/group/groupHttp.js